import { render, staticRenderFns } from "./schedule-form.vue?vue&type=template&id=db42ff68&scoped=true"
import script from "./schedule-form.vue?vue&type=script&lang=js"
export * from "./schedule-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db42ff68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db42ff68')) {
      api.createRecord('db42ff68', component.options)
    } else {
      api.reload('db42ff68', component.options)
    }
    module.hot.accept("./schedule-form.vue?vue&type=template&id=db42ff68&scoped=true", function () {
      api.rerender('db42ff68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/schedule-message/schedule-form.vue"
export default component.exports